import { render, staticRenderFns } from "./Produzione_logistica.vue?vue&type=template&id=f514cca2&"
import script from "./Produzione_logistica.vue?vue&type=script&lang=js&"
export * from "./Produzione_logistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports